// Module imports
import copyToClipboard from "./copyText";

// Initialize popovers
$(() => {
  $('[data-toggle="popover"]').popover();
});

// Event listeners
document.getElementById("copy-video-link").addEventListener("click", () => {
  copyToClipboard("video-link");
});


